import styled from "styled-components";

import {
    portalColors
} from "src/components";

export const CheckInDisplayWrap = styled.div`
    margin-top: ${p => p.$dashboard ? "0" : "20px"};
    padding: ${p => p.$dashboard ? "0" : p.$detail ? "0 1.15rem 1rem" : "0 1.15rem 0.9rem"};
    display: grid;
    gap: 0.35rem;
`;

export const CountText = styled.div`
    color: ${portalColors.mutedText};
    font-size: 0.75rem;
    font-weight: 700;
`;

export const MapFrame = styled.div`
    width: 100%;
    height: 420px;
    min-height: 320px;
    overflow: hidden;
    background: ${portalColors.surfaceSoft};

    @media (max-width: 640px) {
        height: 360px;
        min-height: 300px;
    }
`;

export const ModalContent = styled.div`
    padding: 1rem 1.15rem 1.15rem;
    display: grid;
    gap: 0.55rem;
`;
